import * as React from "react";
import { AppError, IErrorContext } from "../../context/ErrorContext";
import { ErrorContext } from "../../context/ErrorContext/ErrorContext";
import { ErrorDisplay } from "./ErrorDisplay/ErrorDisplay";

export interface IErrorBoundaryProps {
    Error?: AppError;
}

export interface IErrorBoundaryState {
    error?: AppError;
    errorInfo?: React.ErrorInfo;
}

export default class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {

    public static contextType = ErrorContext;

    public context!: React.ContextType<typeof ErrorContext>;

    constructor(props: IErrorBoundaryProps) {
        super(props);

        this.state = {
            error: props.Error,
        };
    }

    public componentDidCatch = (error: Error) => {
        this.context.SetError(error);
    }

    public render = () => {
        return (
            <ErrorContext.Consumer>
                {(context: IErrorContext) =>
                    context.Error !== undefined ?
                        <ErrorDisplay error={context.Error} />
                        :
                        this.props.children
                }
            </ErrorContext.Consumer>
        );
    }
}
